<app-custom-modal [customTitle]="'Borrar ' + item" (closeFunction)="closeFormFunction()"
    (acceptFunction)="acceptFormFunction()">
    <section class="flex flex-col items-center">
        <i class="fa-solid fa-trash-can text-4xl text-red-400"></i>
        <p>¿Deseas borrar {{item}}?</p>
    </section>
</app-custom-modal>